import { RouteManager } from '../../RouteManager';

import { useI18n } from '../../hooks/useI18nFormatters';

import { glyph } from '../../theme/glyph';

import { TabAddMenu } from '../../components/sub-navigation/TabAddMenu';

const KEYS = {
  DEVICE: 'DEVICE',
  ZONE: 'ZONE',
};

export function DevicesAddMenu(props) {
  const { i18n } = useI18n();

  const items = [
    {
      key: KEYS.DEVICE,
      label: i18n.messageFormatter('header.action.device'),
      icon: glyph.system.devices,
    },
    {
      key: KEYS.ZONE,
      label: i18n.messageFormatter('zone.newZone'),
      icon: glyph.system.zone,
    },
  ];

  function handleAction(key) {
    switch (key) {
      case KEYS.DEVICE:
        RouteManager.toNewDevice();
        break;
      case KEYS.ZONE:
        props.onNewZone();
        break;
      default:
        break;
    }
  }

  return (
    <TabAddMenu
      ariaLabel="Devices Add Menu"
      title={i18n.messageFormatter('header.add')}
      items={items}
      onAction={handleAction}
    />
  );
}
